import React from 'react';
import PropTypes from 'prop-types';
import { BookOpen } from 'react-feather';
import i18 from 'i18next';

import type { PlainRestaurant } from 'types/restaurants';
import { plainRestaurantShape } from 'shapes/restaurant';
import { selectTenantConfigs } from 'store/tenants';
import { useAppSelector } from 'hooks/useRedux';
import { getRestaurantPreviewHost, RestaurantPreviewType } from 'utils/preview';

export { RestaurantPreviewType }

const urlPartByType = {
  menu: 'zamawiaj',
  menu_on_place: 'menu',
  reservations: 'rezerwuj',
};

interface IProps {
  color?: string;
  className?: string;
  type: RestaurantPreviewType;
  restaurant: PlainRestaurant;
}

const PreviewLink: React.FC<IProps> = (props) => {
  const { color = 'link', className = '', restaurant, type } = props;

  const tenantConfigs = useAppSelector(selectTenantConfigs);
  const host = getRestaurantPreviewHost(restaurant, type, tenantConfigs);
  const text = i18.t('Restaurant preview');

  return (
    <a
      href={`${host}${urlPartByType[type]}/${restaurant.slug}`}
      className={`btn btn-${color} no-print ${className}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      <BookOpen /> <span>{text}</span>
    </a>
  );
};

PreviewLink.propTypes = {
  color: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.oneOf(Object.values(RestaurantPreviewType)).isRequired,
  restaurant: plainRestaurantShape.isRequired,
};

export default PreviewLink;
